export default "__VITE_ASSET__cR5onk4T__"